import React, { useEffect } from 'react'
import useRewards from '../hooks/rewards/rewards'
import dayjs from 'dayjs'
import QRCode from "react-qr-code";

export default function Reward() {
    let {
        reward,
        setReward,
        getRewardList,
        // redeemRewardById
    } = useRewards()

    // const redeemReward = async (rewardId) => {
    //     let isRedeem = window.confirm("Do you want to redeem this reward?")
    //     if (isRedeem) {
    //         redeemRewardById(rewardId)
    //     }
    // }

    useEffect(() => {
        if (reward.statusCode === "GET_REWARDLIST_SUCCESS") {
            setReward({
                ...reward,
                statusCode: "STAND_BY"
            })
        } else if (reward.statusCode === "REDEEM_REWARD_SUCCESS") {
            alert(`Redeem Success`)
        }
        // eslint-disable-next-line
    }, [reward])

    useEffect(() => {
        getRewardList()
        // eslint-disable-next-line
    }, [])

    return (
        <div className='container'>
            <br />
            <h1 align="center">Reward</h1>
            <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-12 col-xs-12 col-sm-12 col-md-4'>
                    {
                        reward.data && reward.data.map((r, i) => {
                            return (<div key={i} className='card card-body m-3'>
                                <div className='row'>
                                    <div className='col-6'>
                                        <p>{r.detail}</p>
                                        <hr />
                                        <p>Reward Number: {r.rewardNumber}</p>
                                    </div>
                                    <div className='col-6'>
                                        {r.status !== 0 && < img
                                            src="/assets/images/banner.png"
                                            style={{
                                                width: "100%"
                                            }}
                                            alt="logo-band"
                                        />}
                                        {r.status === 0 && <QRCode value={r.rewardNumber}
                                            size={128}
                                        />}
                                    </div>
                                </div>
                                {/* {
                                    r.status === 1 && <div className='row'>
                                        <div className='col card' style={{
                                            backgroundColor: "#0E4D92",
                                            color: "white",
                                            padding: "10px",
                                            margin: "10px"
                                        }}>
                                            {r.rewardNumber}
                                        </div>
                                    </div>
                                } */}
                                <hr />
                                {
                                    r.status === 1 && <div style={{ color: 'red' }}>
                                        ใช้เมื่อวันที่: {dayjs(r.updateDate).format("DD-MM-YYYY HH:mm")}
                                    </div>
                                }
                                {/* <div className="d-grid gap-2">
                                    {
                                        r.status === 0 && <button
                                            className='btn btn-primary'
                                            onClick={() => redeemReward(r._id)}
                                        >Redeem</button>
                                    }
                                    {
                                        r.status !== 0 && <button className='btn btn-primary' disabled>Redeem</button>
                                    }
                                </div> */}
                            </div>)
                        })
                    }
                </div>
            </div>
        </div >
    )
}
